// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".layer-card__bg{position:absolute;top:0;z-index:-1;height:100%;background-color:#e2eaee;-o-object-fit:cover;object-fit:cover}.layer-card__bg--image{background-size:cover}.full-card{margin-top:-300px}@media only screen and (max-width:768px){.full-card{margin-top:-100px}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
